module.exports = __webpack_public_path__ + "img/Bank Sultra.400c720a.png";